/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Kind_ContractInputs */

const vi_cdo_kind_contract = /** @type {(inputs: Cdo_Kind_ContractInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao hợp đồng`)
};

/**

* @param {Cdo_Kind_ContractInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_kind_contract = /** @type {((inputs?: Cdo_Kind_ContractInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Kind_ContractInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_kind_contract(inputs)
});